<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { isStyle } from '@/assets/js/common'
  export default {
    name: 'app',
    data () {
      return {
        name: ''
      }
    },
    created () {
      isStyle()
    },
    mounted () {
    }
  }
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/App.vue